import {createDraftSafeSelector} from '@reduxjs/toolkit';

import channelTypes from '../../consts/channelTypes';
import themeStyle from '../../consts/themeStyle';

const selectGlobalState = (state) => state.global;

export const selectIsAppInitialized = createDraftSafeSelector(selectGlobalState, (state) => state.isAppInitialized);

export const selectIsOnline = createDraftSafeSelector(selectGlobalState, (state) => state.isOnline);

export const selectNotifications = createDraftSafeSelector(selectGlobalState, (state) => state.notifications);

export const selectIsNetworkNotificationsDisabled = createDraftSafeSelector(
    selectGlobalState,
    (state) => state.isNetworkNotificationsDisabled
);

export const selectIsAgeGateConfirmed = createDraftSafeSelector(selectGlobalState, (state) => state.isAgeGateConfirmed);

export const selectIsGetStartedPageShown = createDraftSafeSelector(
    selectGlobalState,
    (state) => state.isGetStartedPageShown
);

export const selectIsPWA = createDraftSafeSelector(selectGlobalState, (state) => state.isPWA);

export const selectIsPWAInstalled = createDraftSafeSelector(selectGlobalState, (state) => state.isPWAInstalled);

export const selectSwMessage = createDraftSafeSelector(selectGlobalState, (state) => state.swMessage);

export const selectGlobalLoader = createDraftSafeSelector(selectGlobalState, (state) => state.globalLoaders);

export const selectIsDarkMode = createDraftSafeSelector(selectGlobalState, (state) => state.theme === themeStyle.DARK);

export const selectTheme = createDraftSafeSelector(selectGlobalState, (state) => state.theme);

export const selectOverriddenTheme = createDraftSafeSelector(selectGlobalState, (state) => state.overriddenTheme);

export const selectIsUseSystemTheme = createDraftSafeSelector(selectGlobalState, (state) => state.isUseSystemTheme);

export const selectIsRetail = createDraftSafeSelector(
    selectGlobalState,
    (state) => state.channelType === channelTypes.RETAIL
);

export const selectIsDevMockSession = createDraftSafeSelector(selectGlobalState, (state) => state.isDevMockSession);
